import React from 'react'
import AdminLayout from './layouts/AdminLayout'
import { Route, Routes } from 'react-router-dom'
import { adminActualityCategoryLink, adminActualityEditLink, adminActualityLink, adminActualityListLink, adminEmissionLink, adminMediaLink, adminProgrammeAddLink, adminProgrammeDetailsLink, adminProgrammeEditLink, adminProgrammeLink, adminUserLink, adminUserManageLink } from './constants/endspoints'
import Admin from './views/admin/Admin'
import Actualities from './views/admin/Actualities'
import Medias from './views/admin/Medias'
import ActualitiesCategory from './views/admin/ActualitiesCategory'
import ActualitiesList from './views/admin/ActualitiesList'
import Emissions from './views/admin/Emissions'
import ActualityEdit from './views/admin/ActualityEdit'
import Programmation from './views/admin/Programmation'
import ProgrammationAdd from './views/admin/ProgrammationAdd'
import ProgrammationDetails from './views/admin/ProgrammationDetails'
import ProgrammationEdit from './views/admin/ProgrammationEdit'
import UserManagement from './views/admin/UserManagement'
import UserManagementAdmin from './views/admin/UserManagementAdmin'

const AdminRoutes = () => {
    return (
        <Routes>
            {/* Admin routes */}
            <Route path="/admin/">
                {/* Actuality */}
                <Route path={adminActualityCategoryLink} element={<AdminLayout><ActualitiesCategory /></AdminLayout>} />
                <Route path={adminActualityListLink} element={<AdminLayout><ActualitiesList /></AdminLayout>} />
                <Route path={adminActualityEditLink+'/:id'} element={<AdminLayout><ActualityEdit /></AdminLayout>} />
                <Route path={adminActualityLink} element={<AdminLayout><Actualities /></AdminLayout>} />

                <Route path={adminProgrammeEditLink+'/:id'} element={<AdminLayout><ProgrammationEdit /></AdminLayout>} />
                <Route path={adminProgrammeDetailsLink+'/:id'} element={<AdminLayout><ProgrammationDetails /></AdminLayout>} />
                <Route path={adminProgrammeAddLink} element={<AdminLayout><ProgrammationAdd /></AdminLayout>} />
                <Route path={adminProgrammeLink} element={<AdminLayout><Programmation /></AdminLayout>} />

                <Route path={adminEmissionLink} element={<AdminLayout><Emissions /></AdminLayout>} />

                <Route path={adminUserLink} element={<AdminLayout><UserManagement /></AdminLayout>} />
                <Route path={adminUserManageLink} element={<AdminLayout><UserManagementAdmin /></AdminLayout>} />

                <Route path={adminMediaLink} element={<AdminLayout><Medias /></AdminLayout>} />
                <Route index element={<AdminLayout><Admin /></AdminLayout>} />
            </Route>
        </Routes>
    )
}

export default AdminRoutes